module.exports = __webpack_public_path__ + "static/img/pay-card-1x.6aa41df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay-card-1x.png
// module id = Cosr
// module chunks = 12